import React from "react";

const PaymentPolicy = () => {
  return (
    <div className="container mx-auto py-8 mt-10 mb-20">
      <h1 className="text-3xl font-bold mb-6 text-center">
        Payment/Refund Policy
      </h1>
      <div className="max-w-2xl mx-auto mb-8">
        <p className="mb-4">Effective Date: 11/08/2023</p>
        <h2 className="font-semibold mb-4">1) Payment Terms:</h2>
        <div className="flex flex-col gap-6">
          <p>
            <span className="font-semibold">1.1. </span>
            All services provided by Fynii InfoTech Private Limited ("the
            Company") shall be subject to the following payment terms, unless
            otherwise agreed upon in writing between the Company and the client:
          </p>
          <p>
            <span className="font-semibold">1.2. </span>
            Invoices will be issued in accordance with the agreed-upon payment
            schedule or upon completion of the services, as specified in the
            contract or agreement.
          </p>
          <p>
            <span className="font-semibold">1.3. </span>
            Payment for the services rendered is due within 30 (thirty days)
            from the date of the invoice, unless otherwise stated in the
            contract or agreement.
          </p>
          <p>
            <span className="font-semibold">1.4. </span>
            The currency of payment shall be Indian Rupees unless otherwise
            agreed upon.
          </p>
        </div>
        <h2 className="font-semibold mt-6 mb-4">2) Payment Methods:</h2>
        <div className="flex flex-col gap-6">
          <p>
            <span className="font-semibold">2.1. </span>
            Payments can be made by the client via the following methods:
          </p>
          <p>
            a) Bank transfer: Clients are required to transfer the invoiced
            amount to the Company's designated bank account. The client is
            responsible for any bank charges associated with the transfer.
          </p>
          <p>
            b) Online payment platforms: The Company provides the convenience of
            online payment options. Clients may make payments using the
            following platforms:
          </p>
          <p>
            i) Razorpay: Clients can securely make online payments through
            Razorpay, a trusted and reliable payment gateway. The available
            payment options on Razorpay will be communicated to the client as
            needed.
          </p>
          <p>
            Note: The Company reserves the right to add or remove payment
            platforms at its discretion. The availability of specific platforms
            may vary based on the client's location and other factors.
          </p>
        </div>
        <h2 className="font-semibold mt-6 mb-4">3) Late Payments:</h2>
        <div className="flex flex-col gap-6">
          <p>
            <span className="font-semibold">3.1. </span>
            In the event of late payment, the client shall be liable for
            interest charges on the outstanding amount at a rate of 12% interest
            per month or the maximum rate permitted by law, whichever is lower.
          </p>
          <p>
            <span className="font-semibold">3.2. </span>
            The Company reserves the right to suspend or terminate services if
            payment is not received within the specified timeframe and after
            reasonable notice has been given to the client.
          </p>
        </div>
        <h2 className="font-semibold mt-6 mb-4">4) Disputed Payments:</h2>
        <div className="flex flex-col gap-6">
          <p>
            <span className="font-semibold">4.1. </span>
            If the client disputes any part of the invoice, the client must
            notify the Company in writing within 3 (three days) from the invoice
            date. Both parties will work together in good faith to resolve the
            dispute promptly.
          </p>
        </div>
        <h2 className="font-semibold mt-6 mb-4">5) Taxes and Fees:</h2>
        <div className="flex flex-col gap-6">
          <p>
            <span className="font-semibold">5.1. </span>
            The client shall be responsible for any applicable taxes, duties, or
            other governmental charges imposed on the services provided by the
            Company, as per the prevailing laws and regulations.
          </p>
        </div>
        <h2 className="font-semibold mt-6 mb-4">6) Confidentiality:</h2>
        <div className="flex flex-col gap-6">
          <p>
            <span className="font-semibold">6.1. </span>
            Any financial or payment-related information exchanged between the
            Company and the client shall be treated as confidential and used
            solely for the purpose of processing payments and maintaining
            financial records.
          </p>
        </div>
        <h2 className="font-semibold mt-6 mb-4">7) Amendments:</h2>
        <div className="flex flex-col gap-6">
          <p>
            <span className="font-semibold">7.1. </span>
            The Company reserves the right to modify this payment policy as
            deemed necessary. Any changes to the policy will be communicated to
            the client in writing or through an updated version on the Company's
            website.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentPolicy;
